import { get } from 'lodash';
import { updateQueryCache } from 'api/urql/helpers/mutation';
import { query } from 'components/pages/components/forms/venueForm/formv2/components/infoForm/graphql/queries';

export const createContact = (results, args, cache, info) => {
  // handlers go here
  updateQueryCache({
    fieldName: 'contacts',
    query,
    handleCacheUpdate: (data) => {
      const contacts = get(data, 'contacts', null);
      if (contacts === null) {
        return null;
      }

      const createdContact = get(results, 'createContact.contact', null);
      if (createdContact !== null) {
        data.contacts.push(createdContact);
      }

      return data;
    },
  })(results, args, cache, info);
};
